
import React from 'react';

const Testimonials = () => {
  const testimonialData = [
    {
      name: "Mette Hansen",
      text: "Oscar har en fantastisk evne til at forklare selv de mest komplekse teknikker på en let forståelig måde. Efter 6 måneder med ham har jeg gjort større fremskridt end i mine foregående 2 år."
    },
    {
      name: "Lars Petersen",
      text: "Jeg begyndte som fuldstændig nybegynder i en alder af 45, og jeg var nervøs for om det var for sent. Oscar har vist mig, at det aldrig er for sent at lære at spille klaver. Hans tålmodighed er utrolig."
    },
    {
      name: "Sofie Andersen",
      text: "Oscars online timer er fantastiske! Teknikken fungerer perfekt, og jeg føler, jeg får lige så meget ud af timerne, som hvis jeg var der fysisk. Det har gjort det muligt for mig at fortsætte undervisningen under mit udvekslingsophold."
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-piano-black">Succeshistorier fra tilfredse elever</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Læs hvad andre elever har oplevet med Oscars klaverundervisning.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonialData.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md">
              <div className="flex flex-col h-full">
                <div className="mb-6">
                  <div className="flex text-piano-gold">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                      </svg>
                    ))}
                  </div>
                </div>
                <blockquote className="text-gray-600 italic mb-6 flex-grow">
                  "{testimonial.text}"
                </blockquote>
                <footer className="mt-auto">
                  <p className="font-medium">{testimonial.name}</p>
                </footer>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-10 text-center">
          <a 
            href="https://dk.trustpilot.com/review/oscargilbert.dk" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-flex items-center text-piano-gold hover:underline"
          >
            <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.2,12.05l-2.79,2.72,0.66,3.84a0.49,0.49,0,0,1-.71.53L14,17.31l-3.39,1.79a0.49,0.49,0,0,1-.71-0.53L10.6,14.71,7.8,12a0.5,0.5,0,0,1,.28-0.85l3.86-.56,1.73-3.48a0.5,0.5,0,0,1,.9,0l1.73,3.48,3.86,0.56A0.5,0.5,0,0,1,20.2,12.05Z" />
            </svg>
            Se Flere Anmeldelser På Trustpilot
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
